import * as React from 'react';
import loadable from '@loadable/component';
import { Helmet } from 'react-helmet-async';
import { SEO_CONSTANTS } from '../../ListingPage/services/seo/constant';
import withMicroFrontendProps from 'Common/Microfrontend';
import { SignupAndLoginProps } from 'Common/appshell_types';

const SignupAndLogin = loadable(() => import('mf-signup-and-login/Main'), {
    ssr: false,
    resolveComponent: components => {
        if (components.default.ShopToClubOverlay) {
            return components.default.ShopToClubOverlay;
        }
        // TODO: remove fallback after mf was deployed to production, after a week.
        // if a old version of microfrontend is deployed we should fallback to the default export.
        // can be removed after the mf version was updated
        return components.default;
    },
}) as SignupAndLoginProps['ShopToClubOverlay'];

const SignupAndLoginWithBellaProps = withMicroFrontendProps(SignupAndLogin, 'mf-signup-and-login');

const SignupAndLoginMicroFrontend = () => (
    <div>
        <Helmet>
            <meta name={SEO_CONSTANTS.robotsMetaName} content={SEO_CONSTANTS.noIndexable} />
        </Helmet>
        <SignupAndLoginWithBellaProps />
    </div>
);

export default SignupAndLoginMicroFrontend;
